import React, { useEffect, useState } from "react";
import AmazonTable from "./AmazonInventory/AmazonTable";
import AmazonSidebar from "./AmazonInventory/AmazonSidebar";
import AmazonFooter from "./AmazonInventory/AmazonFooter";
import { AmazonInventoryCacheProvider, useAmazonInventoryCacheContext } from "../../Context/Cache/AmazonInventory/AmazonInventoryCacheContext";
import BreadCrumb from "../BreadCrumb/BreadCrumb";
import { useAuthenticationContext } from "../../Context/Authentication";
import { AtuInventoryProvider } from "../../Context/Cache/ATU/AtuInventoryContext";
import { useInventoryProductContext } from "../../Context/Cache/InventoryProductContext";
import { FaBars, FaTimes } from 'react-icons/fa';
import { LoadingScreen } from "../LoadingScreen";


const MainAmazonInventory = () => {
  const { screenSize } = useAuthenticationContext()
  const {
categoryData,
subCategoryData,
brandData,
itemCategoryCodeData,
colorData,
packagingData,
selectedCategories,
selectedSubCategories,
selectedBrands,
selectedItemCategoryCodes,
setSelectedCategories,
setSelectedSubCategories,
setSelectedBrands,
setSelectedItemCategoryCodes,
selectedColors,
setSelectedColors,
selectedPackaging,
setSelectedPackaging,
handleCheckboxChange,
fetchFilteredProducts,
fetchDataFromCache,
products,
inventoryFilteredProducts,
applyFilters,
isRangeChanged,
setIsRangeChanged,
clearAllFilters,
showApplyFilterOptions,setShowApplyFilterOptions,
updateApplyFilterOptions,setUpdateApplyFilterOptions,
combinedSelectedItems,setCombinedSelectedItems,
isExpanded, setIsExpanded,
        toggleWidth,skuData,
        setSkuData,
        selectedSku,
        setSelectedSku,visibleColumns,
        setVisibleColumns,
        algopixMarketList,
        selectedMarket,
        setSelectedMarket,
        handleMarketChange,
        clearAllMarketFilter,
        applyMarketFilter,
        attributeMapping,
        appliedSelectedMarket,
        setAppliedSelectedMarket,
        isLoading,
        isRealLoading
} = useAmazonInventoryCacheContext();

const [clearIndividualFilter, setClearIndividualFilter] = useState(false)

const getLabelByValue = (value, data) => {
const item = data.find((item) => item.value === value);
return item ? item.label : value;
};

 // Amit 02-08-2024
   useEffect(()=>{
    if(updateApplyFilterOptions==true){
          setCombinedSelectedItems( [
            ...selectedCategories.map((item) => ({
              label: getLabelByValue(item, categoryData),
              value: item,
              type: "category",
              setSelected: setSelectedCategories,
            })),
            ...selectedSubCategories.map((item) => ({
              label: getLabelByValue(item, subCategoryData),
              value: item,
              type: "subcategory",
              setSelected: setSelectedSubCategories,
            })),
            ...selectedBrands.map((item) => ({
              label: getLabelByValue(item, brandData),
              value: item,
              type: "brand",
              setSelected: setSelectedBrands,
            })),
            ...selectedItemCategoryCodes.map((item) => ({
              label: getLabelByValue(item, itemCategoryCodeData),
              value: item,
              type: "itemCategoryCode",
              setSelected: setSelectedItemCategoryCodes,
            })),
            ...selectedColors.map((item) => ({
              label: getLabelByValue(item, colorData),
              value: item,
              type: "color",
              setSelected: setSelectedColors,
            })),
            ...selectedPackaging.map((item) => ({
              label: getLabelByValue(item, packagingData),
              value: item,
              type: "packaging",
              setSelected: setSelectedPackaging,
            })),
            ...selectedSku.map((item) => ({
              label: getLabelByValue(item, skuData),
              value: item,
              type: "sku",
              setSelected: setSelectedSku,
            })),
          ]);
          setUpdateApplyFilterOptions(false);
    }
 
  },[updateApplyFilterOptions]);
  const handleRemoveItem = async (item) => {
    // Amit 17-09-2024
    if(algopixMarketList.includes(item)){
     
      let tempselectedmarket = appliedSelectedMarket.filter((value)=> value.label!=item.label);
     // setSelectedMarket(tempselectedmarket);
      setAppliedSelectedMarket(tempselectedmarket);
      setSelectedMarket((prev)=> prev.filter((previtem)=> previtem.key!=item.key));
 
        const relatedAttributes = attributeMapping.filter((column)=> column.market==item.label)||[];
        const filteredrelatedAttributes = [];
        relatedAttributes.forEach((value)=>{
          filteredrelatedAttributes.push(value.columnkey);
        })
       
        setVisibleColumns((prev)=> prev.filter((val)=> !filteredrelatedAttributes.includes(val)));
     
     }else{
      item.setSelected((prevSelectedItems) =>
        prevSelectedItems.filter((i) => i !== item.value)
      );
     }
    setClearIndividualFilter(true)
  };
 
  useEffect(() => {
    if (clearIndividualFilter) {
      fetchFilteredProducts()
      setClearIndividualFilter(false)
    }
  }, [clearIndividualFilter])

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
 
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  }

  return (
    <div className="p-2 bg-gray-100 flex flex-col justify-start nycfix-filter-container" style={{maxWidth: `${screenSize.width}px` }}>
     {isLoading && <LoadingScreen />}
     {isRealLoading && <LoadingScreen message="Loading real-time Online inventory. Please wait..." color="#e74c3c" />}
     {screenSize.width > 992 &&(
        <p class="italic text-gray-600 text-sm p-2.5 border-l-4 border-red-600 bg-gray-50 rounded">
        Buy from our best selling Online Inventory with relevant Amazon, Walmart, EBay analytics.
        </p>
      )}
       { (((combinedSelectedItems.length > 0)&&(showApplyFilterOptions == true))||(appliedSelectedMarket.length>0))&&(
        <div className="flex gap-2.5" style={{maxWidth: `${screenSize.width - 50}px`}}>
          <div className="col-lg-3">
            <BreadCrumb />
          </div>
          <div className="col-lg-9 breadcrumb-wrap nycfix-breadcrumb-wrap">
            <nav aria-label="breadcrumb">
              <div className="tags nycfix-tags" >
                Showing
                {[...combinedSelectedItems,...appliedSelectedMarket].map((item, index) => (
                  <span key={index} className="tag">
                    {item.label}{" "}
                    <span
                      className="close-btn"
                      onClick={() => handleRemoveItem(item)}
                    >
                      &times;
                    </span>
                  </span>
                ))}
                <span className="clear-all" onClick={clearAllFilters}>
                  Clear All
                </span>
              </div>
            </nav>
          </div>
        </div>
      )}
        <div className="">
        <div className="row nycfix-row">
            {screenSize.width < 992 && (
              <div className="nycfix-sidebar-icon" onClick={toggleSidebar}>
                {isSidebarOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
              </div>
            )}
            <div className="gap-3 nycfix-row1">
              <div
                className={`nycfix-sidebar-wrapper ${
                  isSidebarOpen ? "open" : ""
                }`}
              >
                <AmazonSidebar />
              </div>
              {screenSize.width < 992 &&(
        <p class="italic text-gray-600 text-sm p-2.5 border-l-4 border-red-600 bg-gray-50 rounded">
        Buy from our best selling Online Inventory  with relevant Amazon, Walmart, EBay analytics
        .
        </p>
      )}
              <div className="">
                <AmazonTable />
              </div>
            </div>
            <AmazonFooter />
          </div>
        </div>
      </div>
  );
};

export default MainAmazonInventory;
